import { ContentType } from "./ContentType";

export class ContentResponse {
	public contentType: ContentType;
	public content: any;
}
